import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class SocketService {
    private socket: Socket;
    private readonly RETAILER_NAMESPACE_URL = environment.baseAPIHost + '/retailerNamespace';

    constructor() {
        // console.log("Socket Service");
        // this.socket = io(environment.baseAPIHost + '/retailerNamespace', { transports: ['websocket'], }); // Replace with your server URL
        // this.socket.emit("order_status_update", {
        //     "_id":"677b649f8fbe316fad14ca11",
        //     "orderStatus":"Packing",
        //     "orderSubStatus":"PreparingOrder"
        // });
        // this.socket.on('connect', () => {
        //     console.log('Connected to Retailer Namespace');
        //     // this.disconnect();
        // });

        // this.socket.
        // this.socket.on('namespaceConnected', (data) => {
        //     console.log('Connected to namespace:', data);
        //     this.disconnect();
        // });
    }
    // Initialize Socket Connection
    connect(retailerId: string): void {
        this.socket = io(this.RETAILER_NAMESPACE_URL, {
            query: { retailerId },
            reconnection: true,             // Enable auto-reconnect
            reconnectionAttempts: 5,       // Number of attempts before giving up
            reconnectionDelay: 5000,
            transports: ['websocket'],
        });

        this.socket.on('connect', () => {
            console.log('Connected to Retailer Namespace');
        });

        this.socket.on('disconnect', () => {
            console.log('Disconnected from Retailer Namespace');
        });
    }


    // Listen for events from the backend
    listen(eventName: string): Observable<any> {
        return new Observable((subscriber) => {
            this.socket.on(eventName, (data) => {
                subscriber.next(data);
            });
        });
    }

    // Emit events to the backend
    emit(eventName: string, data: any): void {
        this.socket.emit(eventName, data);
    }


    // Listen to events
    onEvent(eventName: string): Observable<any> {
        return new Observable((subscriber) => {
            this.socket.on(eventName, (data) => subscriber.next(data));
        });
    }

    // Disconnect from the server
    disconnect(): void {
        if (this.socket) {
            this.socket.disconnect();
            console.log('Disconnected from Socket.IO');
        }
    }

    // Emit events
    emitEvent(eventName: string, data: any): void {
        this.socket.emit(eventName, data);
    }
}
